import useFetchIntegrationAgencySettings from 'hooks/useFetchIntegrationAgencySettings';
import {
  IntegrationEnum,
  IntegrationStatus,
} from 'models/InternalIntegrationSetting';

const useShouldRedirectToIntegrationsList = () => {
  const { data: integrationAgencySettings, isLoading } =
    useFetchIntegrationAgencySettings({
      enumId: IntegrationEnum.ZAPIER,
    });

  const isStatusNotAllowed =
    !isLoading &&
    integrationAgencySettings?.agencySettings?.status !==
      IntegrationStatus.ACTIVE;

  return isStatusNotAllowed;
};

export default useShouldRedirectToIntegrationsList;
